export default class ClassicQuizRankFilters {
  limit?: number = null;
  page?: number = null;

  constructor(filters: any) {
    this.limit = filters?.limit || null;
    this.page = filters?.page || null;
  }

  public constructMainFiltersUrl?() {
    let url = "";

    if (this.limit) {
      url += `&limit=${this.limit}`;
    }

    if (this.page) {
      url += `&page=${this.page}`;
    }

    return url;
  }
}
